export const FACILITY_TYPES = ['Hospital', 'Clinic', 'Laboratory', 'Pharmacy', 'Research Site'] as const;
